import { RuleViewProps } from '@app/src/types/questionRules'
import { QuestionTypes } from '@app/src/wf-constants'
import { Add, ChevronRight } from '@mui/icons-material'
import { Button, IconButton, ListItem, ListItemButton, ListItemText, Stack, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useDrawer } from '../DrawerContext'
import DrawerView, { DrawerViewProps } from '../DrawerView'
import DrawerViewAddQuestionRule from './DrawerViewAddQuestionRule'

const DrawerViewQuestionRules: React.FC<RuleViewProps & Omit<DrawerViewProps, 'title'>> = ({
  rules,
  questionToShow,
  questionsInTemplate,
  sectionsInTemplate,
  handleSaveRule,
  removeRule,
  questionInTemplate,
  ...props
}) => {
  const { formatMessage } = useIntl()
  const { closeDrawer, openDrawer } = useDrawer()

  const ruleItems = useMemo(
    () =>
      rules?.map((rule, index) => (
        <ListItem disablePadding key={`rule-${index}-${rule.ruleType}-${rule.conditionValue}`}>
          <ListItemButton
            onClick={() =>
              openDrawer(
                <DrawerViewAddQuestionRule
                  questionToShow={questionToShow}
                  questionsInTemplate={questionsInTemplate}
                  sectionsInTemplate={sectionsInTemplate}
                  questionInTemplate={questionInTemplate}
                  handleSaveRule={rule => {
                    removeRule?.(index)
                    handleSaveRule(rule)
                  }}
                  defaultValues={rule}
                  removeRule={removeRule}
                  currentRuleIndex={index}
                />,
              )
            }
            dense
            disableGutters
          >
            <ListItemText
              primary={
                <Typography variant="body2" color="text.secondary">
                  {formatMessage({ id: `templateBuilder.questionRules.${rule.ruleType}` })}
                </Typography>
              }
              secondary={
                <Typography variant="body1">{`${formatMessage({ id: 'templateBuilder.questionRules.ifAnswerIs' })} ${questionToShow.questionType.name === QuestionTypes.File ? formatMessage({ id: `templateBuilder.questionRules.${rule.conditionValue}` }) : rule.conditionValue}`}</Typography>
              }
            />
            <IconButton>
              <ChevronRight />
            </IconButton>
          </ListItemButton>
        </ListItem>
      )),
    [rules, questionToShow.questionType.name, formatMessage, openDrawer],
  )

  return (
    <DrawerView
      title={formatMessage({ id: 'templateBuilder.questionRules.addRules' })}
      buttons={[
        {
          label: formatMessage({ id: 'general.close' }),
          onClick: closeDrawer,
        },
      ]}
      stackButtons
      {...props}
    >
      <Stack p={2} spacing={2}>
        {ruleItems}
        <Button
          startIcon={<Add />}
          onClick={() =>
            openDrawer(
              <DrawerViewAddQuestionRule
                questionToShow={questionToShow}
                questionsInTemplate={questionsInTemplate}
                sectionsInTemplate={sectionsInTemplate}
                handleSaveRule={handleSaveRule}
                rules={rules}
                questionInTemplate={questionInTemplate}
              />,
            )
          }
        >
          {formatMessage({ id: 'templateBuilder.questionRules.addRule' })}
        </Button>
      </Stack>
    </DrawerView>
  )
}

export default DrawerViewQuestionRules
